import React, { Component } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { sendStaffAppMetaData } from "../staffApp/eventTriggers";
import withFetchHook from "../withFetchHook";

class InsuranceFormModal extends Component {
  setDefaultStaffAppMetaData = () =>
    sendStaffAppMetaData(this.props.tabDefaultMetaData);

  handleClose() {
    this.props.closeModal();
  }

  handleChange(name, value) {
    this.props.updateField(name, value);
  }

  updateInsurances(insurance) {
    const { organizationName, id } = this.props;

    return this.props.fetch(
      `/organizations/${organizationName}/residents/${id}.json`,
      {
        method: "PATCH",
        headers: {'Content-Type': 'application/json'},
        data: JSON.stringify({
          resident: {
            insurances_attributes: [insurance]
          },
        })
      }
    );
  }

  deleteInsurance() {
    const { insurance, deleteInsurance, closeModal, isStaffApp } = this.props;

    this.setState({ loading: true });

    this.updateInsurances({
      id: insurance.id,
      _destroy: true,
    }).then(() => {
      this.setState({ loading: false });
      deleteInsurance(insurance);
      if (isStaffApp) {
        alert("Insurance was successfully deleted.");
        this.setDefaultStaffAppMetaData();
      }
      closeModal();
    });
  }

  saveInsurance() {
    const { insurance, updateInsurances, closeModal, isStaffApp } = this.props;

    this.setState({ loading: true });

    this.updateInsurances(insurance).then((data) => {
      this.setState({ loading: false });
      updateInsurances(data.insurances);
      if (isStaffApp) {
        alert("Changes were successfully saved.");
        this.setDefaultStaffAppMetaData();
      }
      closeModal();
    });
  }

  saveInsuranceFunction = (e) => {
    this.props.dispatch(this.saveInsurance());
  };

  componentDidMount() {
    document.addEventListener("saveInsurance", this.saveInsuranceFunction);
  }

  componentWillUnmount() {
    document.removeEventListener("saveInsurance", this.saveInsuranceFunction);
  }

  render() {
    const { name, policy_number, group, plan, other, phone_number } =
      this.props.insurance;
    const { isStaffApp, hasDelete, hasEdit } = this.props;
    return (
      <Modal show={this.props.show} onHide={this.handleClose.bind(this)}>
        {!isStaffApp && (
          <Modal.Header closeButton>
            <Modal.Title>Insurance</Modal.Title>
          </Modal.Header>
        )}
        <Modal.Body className={hasEdit ? "" : "form-modal-width"}>
          {hasEdit ? (
            <>
              <Form.Group controlId="insuranceName">
                <Form.Label>Insurance Name</Form.Label>
                <Form.Control
                  value={name}
                  onChange={(e) => {
                    this.handleChange("name", e.target.value);
                  }}
                />
              </Form.Group>
              <Form.Group controlId="insurancePolicyNumber">
                <Form.Label>Policy Number</Form.Label>
                <Form.Control
                  value={policy_number}
                  onChange={(e) => {
                    this.handleChange("policy_number", e.target.value);
                  }}
                />
              </Form.Group>
              <Form.Group controlId="insuranceGroup">
                <Form.Label>Group</Form.Label>
                <Form.Control
                  value={group}
                  onChange={(e) => {
                    this.handleChange("group", e.target.value);
                  }}
                />
              </Form.Group>
              <Form.Group controlId="insurancePlan">
                <Form.Label>Plan</Form.Label>
                <Form.Control
                  value={plan}
                  onChange={(e) => {
                    this.handleChange("plan", e.target.value);
                  }}
                />
              </Form.Group>
              <Form.Group controlId="insuranceOther">
                <Form.Label>Other</Form.Label>
                <Form.Control
                  value={other}
                  onChange={(e) => {
                    this.handleChange("other", e.target.value);
                  }}
                />
              </Form.Group>
              <Form.Group controlId="insurancePhoneNumber">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  value={phone_number}
                  onChange={(e) => {
                    this.handleChange("phone_number", e.target.value);
                  }}
                />
              </Form.Group>
            </>
          ) : (
            <>
              <Form.Group>
                <Form.Label>Insurance Name</Form.Label>
                <div className="form-control-plaintext">{name || 'N/A'}</div>
              </Form.Group>
              <Form.Group>
                <Form.Label>Policy Number</Form.Label>
                <div className="form-control-plaintext">{policy_number || 'N/A'}</div>
              </Form.Group>
              <Form.Group>
                <Form.Label>Group</Form.Label>
                <div className="form-control-plaintext">{group || 'N/A'}</div>
              </Form.Group>
              <Form.Group>
                <Form.Label>Plan</Form.Label>
                <div className="form-control-plaintext">{plan || 'N/A'}</div>
              </Form.Group>
              <Form.Group>
                <Form.Label>Other</Form.Label>
                <div className="form-control-plaintext">{other || 'N/A'}</div>
              </Form.Group>
              <Form.Group>
                <Form.Label>Phone Number</Form.Label>
                <div className="form-control-plaintext">{phone_number || 'N/A'}</div>
              </Form.Group>
            </>
          )}
        </Modal.Body>
        {!isStaffApp ? (
          <Modal.Footer>
            {this.props.action === "edit" &&  hasDelete && (
              <Button
                variant="outline-danger"
                onClick={() => {
                  const { insurance } = this.props;
                  this.deleteInsurance(insurance);
                }}
              >
                Delete
              </Button>
            )}
            <Button
              variant="info"
              onClick={() => {
                this.saveInsurance();
              }}
            >
              {this.props.action === "edit" ? "Update" : "Create"}
            </Button>
          </Modal.Footer>
        ) : (
          <>
            {this.props.action == "edit" && hasDelete && (
              <div className="p-3">
                <Button
                  variant="outline-danger w-100"
                  onClick={() =>
                    this.props.dispatch(
                      this.deleteInsurance(this.props.insurance)
                    )
                  }
                >
                  Delete
                </Button>
              </div>
            )}
          </>
        )}
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    show: state.ui.insuranceModal.show,
    insurance: state.ui.insuranceModal.insurance,
    action: state.ui.insuranceModal.action,
    organizationName: state.organization.name,
    id: state.resident.id,
    isStaffApp: state.config.isStaffApp,
    resident: state.resident,
    resident_tabs: state.config.resident_tabs,
    tabDefaultMetaData: state.config.tab_default_meta_data.find(
      (tab) => tab.detail == "insurances"
    ),
    config: state.config,
    hasDelete: state.current_user.permissions.includes('Delete'),
    hasEdit: state.current_user.permissions.includes('Edit'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: () => dispatch({ type: "CLOSE_INSURANCE_FORM_MODAL" }),
    updateInsurances: (insurances) =>
      dispatch({ type: "UPDATE_INSURANCES", payload: { insurances } }),
    createInsurance: (insurance) =>
      dispatch({ type: "CREATE_INSURANCE", payload: { insurance } }),
    deleteInsurance: (insurance) =>
      dispatch({ type: "DELETE_INSURANCE", payload: { insurance } }),
    updateField: (name, value) =>
      dispatch({ type: "UPDATE_INSURANCE_FIELD", payload: { name, value } }),
    dispatch: (func) => dispatch(funct()),
  };
};

export default withFetchHook(
  connect(mapStateToProps, mapDispatchToProps)(InsuranceFormModal)
);
